import api from './api';

export async function getTopUpsAPI() {
  return api.get(`/api/backoffice/TopUps`).then((response) => response.data);
}

export type CreateTopUpPayload = {
  amount: number;
  notes: string;
  orderIds: string[];
};

export async function createTopUpAPI(payload: CreateTopUpPayload) {
  return api.post(`/api/backoffice/TopUps`, payload).then((response) => response.data);
}
